import { render, staticRenderFns } from "./index.vue?vue&type=template&id=990432f0&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('990432f0')) {
      api.createRecord('990432f0', component.options)
    } else {
      api.reload('990432f0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=990432f0&", function () {
      api.rerender('990432f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transaction/dispensing/index.vue"
export default component.exports